import styled from '@emotion/styled';
import { FormField, type SelectOption } from '@innovationdepartment/proxima-ui';
import ContentContainer from '../ContentContainer';

const FormFieldWrappers = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  & > * {
    flex: 1;
  }
`;

type CreateSeedAudienceAdAccountSelectViewProps = {
  formattedAdAccounts: SelectOption[];
};

const CreateSeedAudienceAdAccountSelectView = (
  props: CreateSeedAudienceAdAccountSelectViewProps
) => {
  const { formattedAdAccounts } = props;

  return (
    <ContentContainer title="Ad account">
      <FormFieldWrappers>
        <FormField
          type="select"
          name="adAccountId"
          options={formattedAdAccounts}
          placeholder="Select an ad account"
        />
        {/* helps to fix layout */}
        <div />
      </FormFieldWrappers>
    </ContentContainer>
  );
};

export default CreateSeedAudienceAdAccountSelectView;
